import classNames from 'classnames';
import type { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import type { PowerUpTestIds } from '@trello/test-ids';
import { getTestId } from '@trello/test-ids';
import {
  useWorkspaceNavigation,
  useWorkspaceNavigationHidden,
} from '@trello/workspace-navigation';

import styles from './Banner.less';

export const Banner: FunctionComponent = () => {
  const [{ expanded: _workspaceNavigationExpanded }] = useWorkspaceNavigation();
  const [{ hidden: _workspaceNavigationHidden }] =
    useWorkspaceNavigationHidden();
  const workspaceNavigationExpanded =
    !_workspaceNavigationHidden && _workspaceNavigationExpanded;

  return (
    <div
      className={classNames(styles.directoryBannerContainer, {
        [styles.workspaceNavigationExpanded]: workspaceNavigationExpanded,
      })}
      data-testid={getTestId<PowerUpTestIds>('pup-banner')}
    >
      <div
        className={classNames(styles.directoryBanner, {
          [styles.workspaceNavigationExpanded]: workspaceNavigationExpanded,
        })}
      >
        <div>
          <h1
            className={styles.bannerHeading}
            data-testid={getTestId<PowerUpTestIds>('pup-banner-header')}
          >
            <FormattedMessage
              id="templates.directory.power-ups-for-trello"
              defaultMessage="Power-Ups for Trello"
              description="Power-Ups for Trello banner heading"
            />
          </h1>
          <p
            className={styles.bannerParagraph}
            data-testid={getTestId<PowerUpTestIds>('pup-banner-paragraph')}
          >
            <FormattedMessage
              id="templates.directory.calendars-custom-fields-repeating-cards-and-so-much-more-with-integrations-like-jira-slack-google-drive-invision-get-your-trello-superpowers-now"
              defaultMessage="Calendars, Voting, Repeating Cards and so much more with integrations like Jira, Slack, Google Drive, InVision - get your Trello superpowers now!"
              description="Banner paragraph"
            />
          </p>
          <div />
        </div>
      </div>
    </div>
  );
};
